import { render, staticRenderFns } from "./usersignrecord-add-or-update.vue?vue&type=template&id=b2e49e00&"
import script from "./usersignrecord-add-or-update.vue?vue&type=script&lang=js&"
export * from "./usersignrecord-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports